<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-28 19:04:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Attendance\AttendanceRecordModiApp\viewAttendanceRecordModiApp.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-08 10:59:55
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_attendanceModifiApp_form_viewTitle')"
    backgroundClass="transparent"
    widthClass="max-1000"
    pad="0"
  >
    <!-- content -->
    <template v-slot:page-main>
      <noContent v-if="!Data" />
      <ApprovalTriger
        v-if="Data"
        :bg-color="Data.approval_bg_color"
        :slide-color="Data.approval_tint_color"
        @triger="
          $toPage(
            '/admin/attendance-modification/detail/' +
              $route.params.params +
              '/approval-detail/' +
              $route.params.params
          )
        "
      >
        <template v-slot:time>
          {{ $getDateTime(Data.operate_utc_datetime, "YYYY/MM/DD HH:mm") }}
        </template>
        <template v-slot:status>
          {{ $getCommonLangValue(Data.status_detail) }}
        </template>
      </ApprovalTriger>

      <Section v-if="Data">
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_attendanceModifiApp_form_swiftNumberLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              v-model="Data.swift_number"
              :label="
                $t('label_essweb_attendanceModifiApp_form_swiftNumberLabel')
              "
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_attendanceModifiApp_form_appliedOnLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              :value="
                $getDateTime(Data.submission_utc_datetime, 'YYYY/MM/DD HH:mm')
              "
              :label="
                $t('label_essweb_attendanceModifiApp_form_appliedOnLabel')
              "
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              label="label_essweb_attendanceModifiApp_form_applicantLabel"
              v-model="user"
              readonly
              chips
              small-chips
              avatar
              two-line
              :items="users"
              item-value="uuid"
              item-text="preferred_name"
            >
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  :src="data.item.staff_avatar"
                  left
                  small
                  :isTemp="data.item.is_temp"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              label="label_essweb_attendanceModifiApp_form_appliedByLabel"
              v-model="user2"
              readonly
              chips
              avatar
              small-chips
              two-line
              :items="users2"
              item-value="uuid"
              item-text="preferred_name"
            >
              <template v-slot:selection.avatar="{ data }">
                <StaffAvatar
                  :src="data.item.staff_avatar"
                  left
                  small
                  :isTemp="data.item.is_temp"
                  :staff_name="data.item.preferred_name"
                />
              </template>
              <template v-slot:selection="{ data }">
                {{ $getCommonLangValue(data.item.preferred_name) }}
              </template>
            </AutoComplete>
          </v-col>
        </v-row>
      </Section>
      <v-card class="pa-0 my-8 elevation-0 rounded-lg" v-if="Data">
        <v-card-text
          class="pa-0 rounded-lg mrc_map scroll_content_no fill-height"
          :style="{
            background: 'url(' + mapbg + ')',
            minHeight: $vuetify.breakpoint.height - 56 - 78 - 72 - 72 + 'px',
          }"
        >
          <!-- 2020-09-19 改为不显示地图 v-show="false"-->
          <!-- 2021-02-22 改为显示地图 v-show="false" mel brain-->
          <v-sheet
            class="panel_btn text-center transparent"
            @click="showMap = true"
            v-if="!showMap"
          >
            <svg-icon size="72" fill="grey" iconClass="NoMap" />
            <div class="primary--text">View Map</div>
          </v-sheet>
          <v-container
            class="
              transparent
              panel_left
              d-flex
              justify-start
              flex-row
              pa-0
              fill-height
              ma-0
            "
            :style="{ width: leftWidth + 30 + 'px' }"
          >
            <v-sheet
              height="100%"
              :width="leftWidth"
              color="rgba(0,0,0,0.38)"
              style="overflow-x: hidden"
              :class="leftWidth == 0 ? 'pa-0' : 'pa-4'"
              class="rounded-l-lg ma-0 scroll_content_y"
            >
              <!-- person -->
              <v-sheet class="rounded-xl px-2" elevation="1">
                <v-list-item dense two-line class="pa-0 ma-0">
                  <v-list-item-avatar size="36" class="mr-1 my-0 pa-0">
                    <StaffAvatar
                      :isTemp="Data.is_temp"
                      size="36"
                      :src="Data.staff_avatar"
                      :staff_name="Data.preferred_name"
                    />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2">
                      {{ $getCommonLangValue(Data.preferred_name) }}
                      <span class="text--secondary text-caption-xs">
                        {{ Data.staff_code }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-body-2">
                      {{ $getCommonLangValue(Data.job_post_name) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-sheet>
              <!-- tag -->
              <v-sheet
                class="
                  transparent
                  d-flex
                  flex-row
                  justify-space-between
                  mt-4
                  align-center
                "
              >
                <div v-if="Data['ess_att_attendance_master']">
                  <v-chip
                    small
                    class="ma-1 white--text"
                    :color="$getTagColors($card_line_colors, 'is_late_1')"
                    v-if="Number(Data['ess_att_attendance_master']['is_late'])"
                    >{{ $t("label_essweb_system_tag_label_lateLabel") }}</v-chip
                  >
                  <v-chip
                    small
                    :color="$getTagColors($card_line_colors, 'is_ot_1')"
                    class="ma-1 white--text"
                    v-if="Number(Data['ess_att_attendance_master']['is_ot'])"
                    >{{ $t("label_essweb_system_tag_label_otLabel") }}</v-chip
                  >
                  <v-chip
                    small
                    v-if="
                      Number(
                        Data['ess_att_attendance_master']['is_missing_punch']
                      )
                    "
                    :color="
                      $getTagColors($card_line_colors, 'is_missing_punch_1')
                    "
                    class="ma-1 white--text"
                    >{{
                      $t("label_essweb_system_tag_label_isMissingPunchLabel")
                    }}</v-chip
                  >
                  <v-chip
                    small
                    v-if="Number(Data['ess_att_attendance_master']['is_adhoc'])"
                    :color="$getTagColors($card_line_colors, 'is_adhoc_1')"
                    class="ma-1 text--primary"
                    >{{
                      $t("label_essweb_system_tag_label_isAdhocLabel")
                    }}</v-chip
                  >
                  <!-- <v-chip
                    small
                    color="#12B282"
                    class="white--text"
                    v-if="
                      Number(Data['ess_att_attendance_master']['is_on_leave'])
                    "
                    >{{
                      $t("label_essweb_system_tag_label_leaveLabel")
                    }}</v-chip> -->
                  <template
                    v-if="
                      Number(Data['ess_att_attendance_master']['is_on_leave'])
                    "
                  >
                    <v-chip
                      small
                      outlined
                      :color="leave.color_code"
                      v-for="(leave, index) in Data[
                        'ess_att_attendance_master'
                      ]['leave_info']"
                      :key="`leave--${index}`"
                      class="ma-1"
                      >{{
                        $getCommonLangValue(leave["leave_type_name"])
                      }}</v-chip
                    >
                  </template>
                  <template
                    v-if="
                      Number(Data['ess_att_attendance_master']['holiday_info'])
                    "
                  >
                    <v-chip
                      small
                      :color="$getTagColors($card_line_colors, 'is_holiday_1')"
                      v-for="(holiday, index) in Data[
                        'ess_att_attendance_master'
                      ]['holiday_info']"
                      :key="`holiday--${index}`"
                      class="ma-1 text--primary"
                      >{{
                        $getCommonLangValue(holiday["holiday_name"])
                      }}</v-chip
                    >
                  </template>
                  <v-chip
                    small
                    class="ma-1 white--text"
                    :color="$getTagColors($card_line_colors, 'is_on_duty_1')"
                    v-if="
                      Number(Data['ess_att_attendance_master']['is_onDuty'])
                    "
                    >{{
                      $t("label_essweb_system_tag_label_isOnDutyLabel")
                    }}</v-chip
                  >
                  <v-chip
                    small
                    class="ma-1 white--text"
                    :color="
                      $getTagColors($card_line_colors, 'is_early_leave_1')
                    "
                    v-if="
                      Number(
                        Data['ess_att_attendance_master']['is_early_leave']
                      )
                    "
                    >{{
                      $t("label_essweb_system_tag_label_earlyLeaveLabel")
                    }}</v-chip
                  >
                  <v-chip
                    small
                    class="ma-1 white--text"
                    :color="$getTagColors($card_line_colors, 'is_absense_1')"
                    v-if="
                      Number(Data['ess_att_attendance_master']['is_absense'])
                    "
                    >{{
                      $t("label_essweb_system_tag_label_absenseLabel")
                    }}</v-chip
                  >
                  <v-chip
                    small
                    class="ma-1 text--primary"
                    :color="
                      $getTagColors($card_line_colors, 'is_work_from_home_1')
                    "
                    v-if="
                      Number(
                        Data['ess_att_attendance_master']['is_work_from_home']
                      )
                    "
                    >{{
                      $t("label_essweb_punchRecord_list_tag_workFromHomeLabbel")
                    }}</v-chip
                  >
                  <v-chip
                    small
                    class="ma-1 text--primary"
                    :color="
                      $getTagColors($card_line_colors, 'is_out_of_office_1')
                    "
                    v-if="
                      Number(
                        Data['ess_att_attendance_master']['is_out_of_office']
                      )
                    "
                    >{{
                      $t("label_essweb_system_tag_label_isOutOfOfficeLabel")
                    }}</v-chip
                  >
                </div>
                <v-btn
                  icon
                  :color="$getTagColors($card_line_colors, 'is_locked_1')"
                  v-if="Number(Data['ess_att_attendance_master']['is_locked'])"
                >
                  <span class="material-icons-round">lock</span>
                </v-btn>
              </v-sheet>
              <!-- shift -->
              <v-sheet
                class="rounded-xl px-3 mt-4"
                style="overflow: hidden"
                elevation="1"
              >
                <v-sheet class="d-flex flex-row justify-space-between">
                  <div style="width: 24px" class="text-center">
                    <svg-icon
                      size="24"
                      :fill="
                        Data['ess_att_attendance_master'][
                          'official_shift_color_code'
                        ]
                      "
                      iconClass="LabeledColour"
                    />
                  </div>
                  <div style="max-width: 40%" class="pl-1">
                    {{
                      $getCommonLangValue(
                        Data["ess_att_attendance_master"]["official_shift_name"]
                      )
                    }}
                  </div>
                  <v-spacer></v-spacer>
                  <div class="text--secondary">
                    {{
                      $getDateTime(
                        Data["ess_att_attendance_master"][
                          "official_start_utc_time"
                        ],
                        "HH:mm"
                      ) +
                      " - " +
                      $getDateTime(
                        Data["ess_att_attendance_master"][
                          "official_end_utc_time"
                        ],
                        "HH:mm"
                      )
                    }}
                  </div>
                </v-sheet>
                <!-- site bug687 -->
                <v-sheet
                  class="d-flex flex-row justify-start"
                  v-if="Data['ess_att_attendance_master']['site_name']"
                >
                  <div style="width: 24px" class="text-center">
                    <svg-icon size="16" fill="grey" iconClass="site" />
                  </div>
                  <div class="pl-1 text--secondary">
                    {{
                      $getCommonLangValue(
                        Data["ess_att_attendance_master"]["site_name"]
                      )
                    }}
                  </div>
                </v-sheet>
                <!-- cost_center_name bug688 -->
                <v-sheet
                  class="d-flex flex-row justify-start"
                  v-if="Data['ess_att_attendance_master']['cost_center_name']"
                >
                  <div style="width: 24px" class="text-center">
                    <svg-icon size="16" fill="grey" iconClass="cost_center" />
                  </div>
                  <div class="pl-1 text--secondary">
                    {{
                      $getCommonLangValue(
                        Data["ess_att_attendance_master"]["cost_center_name"]
                      )
                    }}
                  </div>
                </v-sheet>
                <v-sheet class="d-flex flex-row justify-start">
                  <div style="width: 24px" class="text-center">
                    <span class="material-icons-round text--secondary md-16"
                      >event</span
                    >
                  </div>
                  <div class="pl-1">
                    {{
                      $getCommonLangValue(
                        Data["ess_att_attendance_master"][
                          "leave_type_remark_name"
                        ]
                      )
                    }}
                  </div>
                </v-sheet>
                <v-sheet
                  class="d-flex flex-row justify-start"
                  v-if="Data['ess_att_attendance_master']['remarks']"
                >
                  <div style="width: 24px" class="text-center flex-shrink-1">
                    <svg-icon
                      size="16"
                      fill="rgba(0, 0, 0, 0.54)"
                      iconClass="mini_doc"
                    />
                  </div>
                  <div
                    class="pl-1 text--secondary text-ellipsis-2"
                    style="width: calc(100% - 24px)"
                    :title="Data['ess_att_attendance_master']['remarks']"
                  >
                    {{ Data["ess_att_attendance_master"]["remarks"] }}
                  </div>
                </v-sheet>
              </v-sheet>
              <!-- event -->
              <v-sheet
                elevation="1"
                class="rounded-xl d-flex mt-4 flex-column flex-grow-1"
              >
                <v-sheet
                  class="ma-4"
                  v-for="(item, index) in Data['ess_att_attendance_master'][
                    'ess_att_attendance_detail'
                  ]"
                  :key="`detail${index}`"
                >
                  <v-sheet class="text-subtitle-1" style="width: 100%">{{
                    $getCommonLangValue(item.event_type_name)
                  }}</v-sheet>
                  <v-sheet class="d-flex flex-row justify-start mt-2">
                    <v-sheet
                      width="8"
                      height="auto"
                      color="primary lighten-4 rounded-xl mr-2"
                    ></v-sheet>
                    <v-sheet>
                      <div class="text-subtitle-2 text--secondary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_scheduleShiftTimeLabel"
                          )
                        }}
                      </div>
                      <div class="text-subtitle-2">
                        {{
                          $getDateTime(item.schedule_start_utc_time, "HH:mm") +
                          " - " +
                          $getDateTime(item.schedule_end_utc_time, "HH:mm")
                        }}
                      </div>
                    </v-sheet>
                  </v-sheet>
                  <v-sheet class="d-flex flex-row justify-start mt-2">
                    <v-sheet
                      width="8"
                      height="auto"
                      color="primary lighten-2 rounded-xl mr-2"
                    ></v-sheet>

                    <v-sheet>
                      <div class="text-subtitle-2 text--secondary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_officialShiftTimeLabel"
                          )
                        }}
                      </div>
                      <div class="text-subtitle-2">
                        {{
                          $getDateTime(item.official_start_utc_time, "HH:mm") +
                          " - " +
                          $getDateTime(item.official_end_utc_time, "HH:mm")
                        }}
                      </div>
                    </v-sheet>
                  </v-sheet>
                  <v-sheet class="d-flex flex-row justify-start mt-2">
                    <v-sheet
                      width="8"
                      height="auto"
                      color="primary base rounded-xl mr-2"
                    ></v-sheet>

                    <v-sheet width="100%">
                      <div class="text-subtitle-2 text--secondary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_actualPunchTime"
                          )
                        }}
                      </div>
                      <!-- <div class="text-subtitle-2">
                        {{
                          $getDateTime(
                            item.actual_punch_in_utc_datetime,
                            "HH:mm"
                          ) +
                            " - " +
                            $getDateTime(
                              item.actual_punch_out_utc_datetime,
                              "HH:mm"
                            )
                        }}
                      </div> -->
                      <div
                        class="
                          d-flex
                          flex-row
                          justify-space-between
                          flex-grow-1
                          mt-2
                        "
                        style="width: 100%"
                      >
                        <v-sheet
                          color="transparent text-subtitle-2 text-center rounded"
                          width="50%"
                        >
                          {{
                            $getDateTime(
                              item.actual_punch_in_utc_datetime,
                              "HH:mm"
                            )
                          }}
                        </v-sheet>
                        <div style="width: 20px" class="text-center">-</div>
                        <v-sheet
                          color="transparent text-subtitle-2 text-center rounded"
                          width="50%"
                        >
                          {{
                            $getDateTime(
                              item.actual_punch_out_utc_datetime,
                              "HH:mm"
                            )
                          }}
                        </v-sheet>
                      </div>
                    </v-sheet>
                  </v-sheet>
                  <v-sheet class="d-flex flex-row justify-start mt-2">
                    <v-sheet
                      width="8"
                      height="auto"
                      color="primary rounded-xl mr-2"
                    ></v-sheet>

                    <v-sheet width="100%">
                      <div class="text-subtitle-2 text--secondary">
                        {{
                          $t(
                            "label_essweb_attendanceModifiApp_form_officialPunchTime"
                          )
                        }}
                      </div>
                      <div
                        class="
                          d-flex
                          flex-row
                          justify-space-between
                          flex-grow-1
                          mt-2
                        "
                        style="width: 100%"
                      >
                        <v-sheet
                          color="transparent text-subtitle-2 text-center rounded"
                          width="50%"
                        >
                          {{
                            $getDateTime(
                              item.official_punch_in_utc_datetime,
                              "HH:mm"
                            )
                          }}
                        </v-sheet>
                        <div style="width: 20px" class="text-center">-</div>
                        <v-sheet
                          color="transparent text-subtitle-2 text-center rounded"
                          width="50%"
                        >
                          {{
                            $getDateTime(
                              item.official_punch_out_utc_datetime,
                              "HH:mm"
                            )
                          }}
                        </v-sheet>
                      </div>
                      <!-- 2021-03-19 不显示 brain lsj -->
                      <div class="mt-2" v-if="false">
                        <v-chip small>
                          {{
                            $t(
                              "label_essweb_attendanceModifiApp_form_totalLabel"
                            )
                          }}({{ $timeMachine(item.total_minutes, false) }})
                        </v-chip>
                        <v-chip
                          small
                          color="red"
                          v-if="Number(item.late_minutes) > 0"
                        >
                          {{
                            $t(
                              "label_essweb_attendanceModifiApp_form_lateLabel"
                            )
                          }}({{ $timeMachine(item.late_minutes, false) }})
                        </v-chip>
                        <!-- <v-chip
                          small
                          color="red"
                          v-if="Number(item.late_minutes) > 0"
                        >
                          {{
                            $t(
                              "label_essweb_attendanceModifiApp_form_lateLabel"
                            )
                          }}({{ $timeMachine(item.late_minutes, false) }})
                        </v-chip> -->
                        <v-chip
                          small
                          color="red"
                          v-if="Number(item.early_leave_minutes) > 0"
                        >
                          {{
                            $t(
                              "label_essweb_attendanceModifiApp_form_earlyLeaveLabel"
                            )
                          }}({{
                            $timeMachine(item.early_leave_minutes, false)
                          }})
                        </v-chip>
                        <v-chip
                          small
                          color="primary"
                          v-if="
                            Number(item.ot_minutes_before) +
                            Number(item.ot_minutes_after)
                          "
                        >
                          {{
                            $t("label_essweb_attendanceModifiApp_form_otLabel")
                          }}({{
                            $timeMachine(
                              Number(item.ot_minutes_before) +
                                Number(item.ot_minutes_after),
                              false
                            )
                          }})
                        </v-chip>
                      </div>
                    </v-sheet>
                  </v-sheet>
                </v-sheet>
              </v-sheet>
            </v-sheet>
            <v-sheet
              width="30"
              height="60"
              :elevation="2"
              class="
                mt-6
                align-center
                text-center
                align-items-center
                text--primary
                rounded-r-lg
                d-flex
                flex-column
                title
              "
              color="white"
              style="cursor: pointer"
              @click="slideOpen = !slideOpen"
            >
              <span class="material-icons-round ma-auto">{{
                slideOpen ? "arrow_left" : "arrow_right"
              }}</span>
            </v-sheet>
          </v-container>
          <!-- right -->
          <v-sheet
            :width="showTab ? 350 : 100"
            :height="!showTab ? 40 : undefined"
            elevation="1"
            class="pa-1 rounded-lg panel_right"
          >
            <v-btn
              style="
                position: absolute;
                right: 5px;
                z-index: 10;
                margin-top: 0px;
              "
              icon
              @click="showTab = !showTab"
            >
              <span class="material-icons-round">{{
                showTab ? "keyboard_arrow_up" : "keyboard_arrow_down"
              }}</span>
            </v-btn>
            <span
              v-show="!showTab"
              class="material-icons-round text--secondary"
              style="
                position: absolute;
                right: 60px;
                z-index: 10;
                margin-top: 5px;
              "
              >bar_chart</span
            >
            <Taber
              :curTab="curTab"
              @change="(tab) => (curTab = tab)"
              :items="taber"
              v-if="showTab"
              :height="40"
              special
              backgroundColor="white"
              :centered="false"
              :showTab="showTab"
              :grow="false"
            >
              <template v-slot:content-1>
                <div class="px-3">
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "official_working_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "official_break_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "official_meal_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t("label_essweb_attendanceModifiApp_form_totalOTLabel")
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "official_total_ot_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalLateLabel"
                        )
                      }}
                    </div>

                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "official_total_late_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "official_total_early_leave_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "official_total_leave_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "official_absense_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "official_before_work_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "official_after_work_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-slot:content-2>
                <div class="px-3">
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "actual_working_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "actual_break_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "actual_meal_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t("label_essweb_attendanceModifiApp_form_totalOTLabel")
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "actual_ot_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalLateLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "actual_late_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "actual_early_leave_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "actual_leave_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "actual_absense_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "actual_before_work_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                  <div class="d-flex flex-row">
                    <div
                      style="width: 50%"
                      class="text-subtitle-2 text--primary"
                    >
                      {{
                        $t(
                          "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                        )
                      }}
                    </div>
                    <div class="text-center flex-grow-1">
                      {{
                        $timeMachine(
                          Data["ess_att_attendance_master"][
                            "actual_after_work_minutes"
                          ] || 0,
                          false
                        )
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </Taber>
          </v-sheet>

          <!-- v-if="showMap && markers.length > 0" 没有打卡记录不显示地图 brain 2021-06-04-->
          <GmapMap
            :center="center"
            v-if="showMap && markers.length > 0"
            :zoom="18"
            ref="curmap"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              keyboardShortcuts: false,
              gestureHandling: 'greedy',
              fullscreenControl: false,
              disableDefaultUi: false,
              controlSize: 22,
            }"
            map-type-id="roadmap"
            style="width: 100%; height: 100%"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :option="{ animation: 'drop', shape: 'circle' }"
              :position="m.position"
              :icon="makericon"
              :clickable="true"
              :draggable="false"
              @click="toggleInfoWindow(m, index)"
            />
            <!-- size: new google.maps.Size(20, 20),
                  origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(0, 20)-->
            <gmap-info-window
              class="mb-4"
              :options="{
                pixelOffset: {
                  width: 0,
                  height: -70,
                },
              }"
              :position="infoWindowPos"
              :opened="infoWinOpen"
              @closeclick="infoWinOpen = false"
            >
              <v-sheet width="200" class="pl-n3">
                <!-- shift -->
                <v-sheet
                  class="d-flex flex-row justify-start align-center py-3"
                >
                  <div style="width: 24px" class="text-center">
                    <svg-icon
                      size="24"
                      :fill="Data['official_shift_color_code']"
                      iconClass="LabeledColour"
                    />
                  </div>
                  <div
                    style="max-width: 80%"
                    class="pl-1 d-inline-block text-truncate text-body-1"
                  >
                    {{ $getCommonLangValue(Data["official_shift_name"]) }}
                  </div>
                </v-sheet>
                <!-- event -->
                <v-sheet
                  class="d-flex flex-row justify-start my-2"
                  v-for="(item, index) in curRecord"
                  :key="`record---${index}`"
                >
                  <v-sheet
                    width="1"
                    height="auto"
                    color="black   mr-2"
                  ></v-sheet>
                  <v-sheet>
                    <div class="text-subtitle-2 text--secondary py-1">
                      {{ $getCommonLangValue(item.event_type_name) }}({{
                        item["punch_type"] == 1
                          ? $t("label_essweb_attendanceRecord_list_inLabel")
                          : item["punch_type"] == 2
                          ? $t("label_essweb_attendanceRecord_list_outLabbel")
                          : ""
                      }})
                    </div>
                    <v-sheet class="d-flex align-center flex-row justify-start">
                      <span class="material-icons-round text--secondary">
                        schedule
                      </span>
                      <div
                        class="text-subtitle-2 grey lighten-3 px-8 ml-2 rounded"
                      >
                        {{
                          $getDateTime(
                            item["punch_type"] == 1
                              ? item["actual_punch_in_utc_datetime"]
                              : item["punch_type"] == 2
                              ? item["actual_punch_out_utc_datetime"]
                              : "",
                            "HH:mm"
                          )
                        }}
                      </div>
                    </v-sheet>
                  </v-sheet>
                </v-sheet>
              </v-sheet>
            </gmap-info-window>
            <!-- icon="//www.google.com/images/branding/product/ico/maps15_bnuw3a_32dp.ico" -->
          </GmapMap>
        </v-card-text>
      </v-card>
      <Section v-if="Data">
        <v-row>
          <!-- <v-col  xs='12' sm="6" md='6' lg='6' cols="12" v-if="Data.punch_attachment_url.length">
              <v-list v-if="Data.punch_attachment_url">
                <v-list-item
                  two-line
                  v-for="(item,index) in Data.punch_attachment_url"
                  :key="index"
                >
                  <v-list-item-avatar tile>
                    <v-img :src="item"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>-->
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_attendanceModifiApp_form_reasonLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              v-model="Data.attendance_modification_reason_text"
              :label="$t('label_essweb_attendanceModifiApp_form_reasonLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_attendanceModifiApp_form_messageLabel")
            }}</v-sheet>
            <v-text-field
              readonly
              v-model="Data.remarks"
              :label="$t('label_essweb_attendanceModifiApp_form_messageLabel')"
              single-line
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </Section>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import makericon from "@/assets/AttendancePoint.png";
import mapbg from "@/assets/mapbg.svg";
import { gmapApi } from "vue2-google-maps";
export default {
  name: "viewPunchVerifyFailedApplication",
  computed: {
    ...mapGetters(["companyLang", "AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    leftWidth() {
      return this.slideOpen ? 375 : 0;
    },
  },
  data() {
    return {
      Data: null,
      users: [],
      mapbg: mapbg,
      curTab: "tab-1",
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      curRecord: [],
      showMap: true,
      showTab: true,
      page_params: null,
      google: null,
      taber: [
        "label_essweb_attendanceModifiApp_form_tab_officialLabel",
        "label_essweb_attendanceModifiApp_form_tab_actualLabel",
      ],
      slideOpen: true,
      makericon: makericon,
      center: { lat: 1.312878, lng: 103.837811 },
      markers: [],
      user: null,
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.getDetail();
    const that = this;
    if (this.$vuetify.breakpoint.name == "xs") {
      this.showTab = false;
    }
    if (
      this.curAppInfo["user"]["latitude"] != undefined &&
      this.curAppInfo["user"]["longitude"] != undefined
    ) {
      this.center = {
        lat: Number(this.curAppInfo["user"]["latitude"]),
        lng: Number(this.curAppInfo["user"]["longitude"]),
      };
    }
    this.$gmapApiPromiseLazy().then(() => {
      that.google = new gmapApi();
    });
  },
  methods: {
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      this.curRecord = marker.record;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    setCenter: function (position) {
      const that = this;
      this.$refs.curmap.$mapPromise.then((map) => {
        map.setCenter(position);
        that.center = position;
      });
    },
    toDelete: function () {},
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_attendance_modification_application",
        url: "/attendance-modification-application/get-details/",
        data: { uuid: this.page_params.id },
      }).then((res) => {
        if (res.data["ess_punch_records"])
          if (res.data["ess_punch_records"].length > 0) {
            res.data["ess_punch_records"].map((item) => {
              that.center = {
                lat: Number(item.latitude),
                lng: Number(item.longitude),
              };
              let arr = [];
              res.data["ess_att_attendance_detail"].map((ite) => {
                if (ite["actual_punch_in_uuid"] == item["uuid"]) {
                  let obj = JSON.parse(JSON.stringify(ite));
                  obj["punch_type"] = 1;
                  arr.push(obj);
                }
                if (ite["actual_punch_out_uuid"] == item["uuid"]) {
                  let obj = JSON.parse(JSON.stringify(ite));
                  obj["punch_type"] = 2;
                  arr.push(obj);
                }
              });
              that.markers.push({
                open: false,
                uuid: item.uuid,
                punch_type: item.punch_type,
                punch_utc_datetime: item.punch_utc_datetime,
                object: item,
                record: arr,
                position: {
                  lat: Number(item.latitude),
                  lng: Number(item.longitude),
                },
              });
            });
          }
        that.user = res.data.uuid;
        that.users = [
          {
            staff_avatar: res.data.staff_avatar,
            uuid: res.data.uuid,
            preferred_name: res.data.preferred_name,
          },
        ];
        that.user2 = res.data.uuid;
        that.users2 = [
          {
            staff_avatar: res.data.submit_staff_avatar,
            uuid: res.data.uuid,
            preferred_name: res.data.submit_preferred_name,
          },
        ];
        // if (res.data["attendance_modification_reason_text"]) {
        //   res.data["attendance_modification_reason_text_save"] =
        //     res.data.attendance_modification_reason_text;
        //   res.data.attendance_modification_reason_text = that.$transOnLineCommonLangKey(
        //     that.companyLang,
        //     res.data.attendance_modification_reason_text
        //   );
        // }
        // if (res.data.punch_attachment_url) {
        //   if (res.data.punch_attachment_url.indexOf(",") != -1) {
        //     res.data.punch_attachment_url =
        //       res.data.punch_attachment_url.split[","];
        //   }
        // } else {
        //   res.data.punch_attachment_url = [];
        // }

        that.Data = res.data;
      });
    },
  },
};
</script>
<style scoped>
.panel_left {
  position: absolute;
  z-index: 999;
}
.panel_btn {
  position: absolute;
  z-index: 999;
  top: 50%;
  left: 50%;
  margin-top: -40px;
  margin-left: -30px;
}
.panel_right {
  position: absolute;
  right: 20px;
  margin-top: 20px;
  z-index: 9;
}
.mrc_map {
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
</style>
